import React from 'react';
import { useTranslation } from 'react-i18next';

interface DragOverlayProps {
  show: boolean;
  isMobile: boolean;
}

export const DragOverlay: React.FC<DragOverlayProps> = ({ show, isMobile }) => {
  const { t } = useTranslation();
  if (!show) return null;

  const text = isMobile ? t('common.swipe_to_scroll') : t('common.click_arrows_to_scroll');

  return (
    <div
      aria-hidden="true"
      className="
        absolute bottom-2 left-1/2 -translate-x-1/2
        flex items-center gap-1.5
        px-3 py-1.5
        bg-black/75 backdrop-blur-sm
        border border-white/10
        rounded-full
        text-xs font-medium text-neutral-300
        z-[5]
        pointer-events-none
      "
    >
      <span className="opacity-80">←</span>
      <span>{text}</span>
      <span className="opacity-80">→</span>
    </div>
  );
};
